<template>
  <v-card class="mx-auto rounded-card card-shadow">
    <v-card-text class="text--primary" v-if="!loading">
      <v-row class="headline font-weight-bold mb-1">
        <v-col cols="12">
          {{user.nome}}
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-icon>mdi-email</v-icon> {{user.email}}
        </v-col>
      </v-row>
      <v-row v-if="user.whatsapp">
        <v-col cols="12">
          <v-icon>mdi-phone</v-icon> {{user.whatsapp}}
        </v-col>
      </v-row>
      <v-divider/>
      <v-row class="title font-weight-bold">
        <v-col>
          Segurança
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <px-alterar-senha-dialog />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import AlterarSenhaDialog from '@/modules/login/alterar-senha/AlterarSenhaDialog.vue';

export default {
  props: {
    user: Object,
    loading: Boolean,
  },
  data() {
    return {
      tab: 0,
    };
  },
  methods: {},
  components: {
    pxAlterarSenhaDialog: AlterarSenhaDialog,
  },
};
</script>
